import React, { useMemo, useState } from 'react';
import { Layout } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
// import { logout } from '../../services/auth';
import { ROUTES } from '../../constants/routes';
import userIcon from '../../assets/user.svg';
import rightIcon from '../../assets/right.svg';
import collapsedIcon from '../../assets/collapsed.svg';
import fileIcon from '../../assets/file.svg';
import recycleBinIcon from '../../assets/recycleBin.svg';
import filetype from '../../assets/filetype.svg';
import folderIcon from '../../assets/folder.svg';
import arrowBtmIcon from '../../assets/arrowBtm.svg';
import addIcon from '../../assets/addIcon.svg';
import logoZh from '../../assets/logoZH.svg';
import logoEn from '../../assets/logoEN.svg';
import moreIcon from '../../assets/more.svg';


import { useUserStore, useFilesStore } from '../../stores';
import { isChineseLanguage, t } from '../../locales';
import AddFolder from './components/AddFolder'
import EditFolder from './components/EditFolder'
import DeleteFolder from './components/DeleteFolder'

import './index.scss'
import Vip from './components/vip';
import useFolderStore from '../../stores/folderStore';

const { Content, Sider } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [fileTypesExpanded, setFileTypesExpanded] = useState(true);
  const [folderExpanded, setFolderExpanded] = useState(true);
  const [showFileTypesPopover, setShowFileTypesPopover] = useState(false);
  const [showFolderAddModal, setShowFolderAddModal] = useState(false);
  const [showFoldersPopover, setShowFoldersPopover] = useState(false);
  const [showFileAllPopover, setShowFileAllPopover] = useState(false);
  const [showRecycleFilePopover, setShowRecycleFilePopover] = useState(false);
  const [hoveredFolder, setHoveredFolder] = useState<number | null>(null);
  const [showFolderMenu, setShowFolderMenu] = useState<number | null>(null);
  const [editingFolder, setEditingFolder] = useState<{ folderId: number, folderName: string } | null>(null);
  const [deletingFolder, setDeletingFolder] = useState<{ folderId: number, folderName: string } | null>(null);

  const { currentUser } = useUserStore();
  const { fileTypes } = useFilesStore();
  const { folders } = useFolderStore();

  // 获取登录方式和显示信息
  const loginType = localStorage.getItem('loginType') || 'email';
  const userDisplayInfo = loginType === 'phone' ? currentUser?.phone || currentUser?.email : currentUser?.email;

  const totalFiles = useMemo(() => {
    if (fileTypes.length) {
      return fileTypes.filter(i => i.name !== 'recycle').reduce((acc, item) => acc + item.count, 0);
    }
    return 0
  }, [fileTypes])

  const recycleFiles = useMemo(() => {
    if (fileTypes.length) {
      return fileTypes.filter(i => i.name === 'recycle').reduce((acc, item) => acc + item.count, 0);
    }
    return 0
  }, [fileTypes])

  const isZH = isChineseLanguage()

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ color: 'white', fontSize: '20px' }}>Ear Dance</div>
        <Menu theme="dark" mode="horizontal" style={{ flex: 1, justifyContent: 'flex-end' }}>
          <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
            退出登录
          </Menu.Item>
        </Menu>
      </Header> */}
      <Layout>
        <Sider
          width={253}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          theme="light"
          trigger={null}
          collapsedWidth={64}
        >
          <div className={`main-nav-container ${collapsed ? 'small-nav-hide' : ''}`}>
            <div className='main-nav-top'>
              <div className='main-logo'>
                <div className={`main-logo-info ${collapsed ? 'hidden' : ''}`}>
                  <img src={isZH ? logoZh : logoEn} alt="" className='logo-img' />
                </div>
                <div className='collapse-icon'>
                  <img src={collapsedIcon} alt="" onClick={() => setCollapsed(!collapsed)} />
                </div>
              </div>
              <div className='main-file-list'>
                <div
                  className={`main-file-all ${location.pathname === ROUTES.FILE && !location.search ? 'active' : ''}`}
                  onClick={() => navigate(ROUTES.FILE)}
                  onMouseEnter={() => setShowFileAllPopover(true)}
                  onMouseLeave={() => setShowFileAllPopover(false)}
                >
                  <div className='main-file-all-left'>
                    <img src={fileIcon} alt="" />
                    <span className={collapsed ? 'hidden' : ''}>{t('aside.allFile')}</span>
                  </div>
                  <span className={`${collapsed ? 'hidden' : ''}`}>{totalFiles}</span>
                  {
                    collapsed && showFileAllPopover && (
                      <div className='fixed-hide-all-con' onClick={() => setShowFileAllPopover(false)}>
                        <div className='fixed-hide-all-content-outer'>
                          <div className='fixed-hide-all-content'>
                            <span>{t('aside.allFile')}</span>
                            <span>{totalFiles}</span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {
                    collapsed && showFileAllPopover && (
                      <div className='fixed-hide-all-con' onClick={() => setShowFileAllPopover(false)}>
                        <div className='fixed-hide-all-content-outer'>
                          <div className='fixed-hide-all-content'>
                            <span>{t('aside.allFile')}</span>
                            <span>{totalFiles}</span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
                {/* 回收站 */}
                <div
                  className={`main-file-all ${location.pathname === ROUTES.FILE && location.search === `?sourceType=recycle` ? 'active' : ''}`}
                  onClick={() => navigate(`${ROUTES.FILE}?sourceType=recycle`)}
                  onMouseEnter={() => setShowRecycleFilePopover(true)}
                  onMouseLeave={() => setShowRecycleFilePopover(false)}
                >
                  <div className='main-file-all-left'>
                    <img src={recycleBinIcon} alt="" />
                    <span className={collapsed ? 'hidden' : ''}>{t('file.recycle')}</span>
                  </div>
                  <span className={`${collapsed ? 'hidden' : ''}`}>{recycleFiles}</span>
                  {
                    collapsed && showRecycleFilePopover && (
                      <div className='fixed-hide-all-con' onClick={() => setShowRecycleFilePopover(false)}>
                        <div className='fixed-hide-all-content-outer'>
                          <div className='fixed-hide-all-content'>
                            <span>{t('file.recycle')}</span>
                            <span>{recycleFiles}</span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
                {/* 全部文件夹 */}
                <div className='main-file-types'>
                  <div className='main-file-cate'>
                    <span className={collapsed ? 'hidden' : ''}>{t('aside.allFolder')}</span>
                    <div>
                      <img
                        src={addIcon}
                        alt=""
                        className={`${collapsed ? 'hidden' : ''} create-folder-icon`}
                        onClick={() => setShowFolderAddModal(true)}
                      />
                      <img
                        src={arrowBtmIcon}
                        alt=""
                        className={`${collapsed ? 'hidden' : ''} ${folderExpanded ? 'expanded' : ''}`}
                        onClick={() => setFolderExpanded(!folderExpanded)}
                      />
                    </div>
                  </div>
                  {
                    folderExpanded && (
                      <>
                        {
                          folders.length
                            ? folders.map((item) => (
                              <div
                                key={item.folderId}
                                className={`main-file-cate-item ${location.pathname === ROUTES.FILE && location.search === `?folderId=${item.folderId}` ? 'active' : ''} ${collapsed ? 'hidden' : ''}`}
                                onClick={() => navigate(`${ROUTES.FILE}?folderId=${item.folderId}`)}
                                onMouseEnter={() => setHoveredFolder(item.folderId)}
                                onMouseLeave={() => {
                                  setHoveredFolder(null);
                                  setShowFolderMenu(null);
                                }}
                              >
                                <span>{item.folderName}</span>
                                <div className='folder-item-right' onClick={(e) => e.stopPropagation()}>
                                  <span 
                                    className={`folder-count ${hoveredFolder === item.folderId ? 'hidden' : ''}`}
                                  >
                                    {item.recordingCount}
                                  </span>
                                  <div 
                                    className={`folder-more-icon ${hoveredFolder === item.folderId ? 'visible' : ''}`}
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseEnter={() => setShowFolderMenu(item.folderId)}
                                  >
                                    <img
                                      src={moreIcon}
                                      alt={t('common.more')}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    />
                                    {showFolderMenu === item.folderId && (
                                      <div 
                                        className='folder-menu-dropdown'
                                        onMouseEnter={() => setShowFolderMenu(item.folderId)}
                                      >
                                        <div 
                                          className='folder-menu-item'
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingFolder({ folderId: item.folderId, folderName: item.folderName });
                                            setShowFolderMenu(null);
                                            setHoveredFolder(null);
                                          }}
                                        >
                                          {t('common.edit')}
                                        </div>
                                        <div 
                                          className='folder-menu-item'
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setDeletingFolder({ folderId: item.folderId, folderName: item.folderName });
                                            setShowFolderMenu(null);
                                            setHoveredFolder(null);
                                          }}
                                        >
                                          {t('common.delete')}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                            : collapsed ? null : <div className='no-folder'>{t('aside.noFolder')}</div>
                        }
                      </>
                    )
                  }
                  {
                    collapsed && !!folders.length && (
                      <div
                        className={`main-file-types-hide ${location.pathname === ROUTES.FILE && location.search && location.search.startsWith('?folderId') ? 'active' : ''}`}
                        onMouseEnter={() => setShowFoldersPopover(true)}
                        onMouseLeave={() => setShowFoldersPopover(false)}
                      >
                        <img src={folderIcon} alt="" />
                        {
                          showFoldersPopover && (
                            <div className='fixed-hide-types-con'>
                              <div className='fixed-hide-types-content-outer'>
                                <div className='fixed-hide-types-content'>
                                  {
                                    folders.map((item) => (
                                      <div
                                        key={item.folderId}
                                        className={`${location.pathname === ROUTES.FILE && location.search === `?folderId=${item.folderId}` ? 'active' : ''}`}
                                        onClick={() => { navigate(`${ROUTES.FILE}?folderId=${item.folderId}`); setShowFoldersPopover(false) }}
                                      >
                                        <span>{item.folderName}</span>
                                        <span>{item.recordingCount}</span>
                                      </div>
                                    ))
                                  }
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    )
                  }
                </div>
                {/* 全部类型 */}
                <div className='main-file-types'>
                  <div className='main-file-cate'>
                    <span className={collapsed ? 'hidden' : ''}>{t('aside.allTypes')}</span>
                    <img
                      src={arrowBtmIcon}
                      alt=""
                      className={`${collapsed ? 'hidden' : ''} ${fileTypesExpanded ? 'expanded' : ''}`}
                      onClick={() => setFileTypesExpanded(!fileTypesExpanded)}
                    />
                  </div>
                  {
                    fileTypesExpanded && fileTypes.filter(i => i.name !== 'recycle').map((item) => (
                      <div
                        key={item.sourceType}
                        className={`main-file-cate-item ${location.pathname === ROUTES.FILE && location.search === `?isCate=1&sourceType=${item.sourceType}` ? 'active' : ''} ${collapsed ? 'hidden' : ''}`}
                        onClick={() => navigate(`${ROUTES.FILE}?isCate=1&sourceType=${item.sourceType}`)}
                      >
                        <span>{item.name}</span>
                        <span>{item.count}</span>
                      </div>
                    ))
                  }
                </div>
                {
                  collapsed && (
                    <div
                      className={`main-file-types-hide ${location.pathname === ROUTES.FILE && location.search && location.search.startsWith('?isCate=1') ? 'active' : ''}`}
                      onMouseEnter={() => setShowFileTypesPopover(true)}
                      onMouseLeave={() => setShowFileTypesPopover(false)}
                    >
                      <img src={filetype} alt="" />
                      {
                        showFileTypesPopover && (
                          <div className='fixed-hide-types-con'>
                            <div className='fixed-hide-types-content-outer'>
                              <div className='fixed-hide-types-content'>
                                {
                                  fileTypes.filter(i => i.name !== 'recycle').map((item) => (
                                    <div
                                      key={item.sourceType}
                                      className={`${location.pathname === ROUTES.FILE && location.search === `?isCate=1&sourceType=${item.sourceType}` ? 'active' : ''}`}
                                      onClick={() => { navigate(`${ROUTES.FILE}?isCate=1&sourceType=${item.sourceType}`); setShowFileTypesPopover(false) }}
                                    >
                                      <span>{item.name}</span>
                                      <span>{item.count}</span>
                                    </div>
                                  ))
                                }
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            {/* 底部 */}
            <div className='main-nav-btm'>
              {/* 会员卡片区域 */}
              <div className={`main-vip-section ${collapsed ? 'hidden' : ''}`}>
                <Vip />
              </div>
              <div className={`main-user-entry`} onClick={() => navigate(ROUTES.PROFILE)}>
                <div className='main-user'>
                  <div className='main-user-avatar'>
                    <img src={userIcon} alt="" />
                  </div>
                  <div className={`main-user-name ${collapsed ? 'hidden' : ''}`}>{userDisplayInfo}</div>
                </div>
                <img src={rightIcon} alt="" className={`main-user-right-icon ${collapsed ? 'hidden' : ''}`} />
              </div>
            </div>
          </div>
        </Sider>
        <Layout style={{}}>
          <Content
            style={{
              margin: 0,
              minHeight: '100%',
              background: '#fff',
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>

      {
        showFolderAddModal && (
          <AddFolder
            onSuccess={() => { }}
            onCancel={() => {
              setShowFolderAddModal(false);
            }}
          />
        )
      }

      {
        editingFolder && (
          <EditFolder
            folderId={editingFolder.folderId}
            folderName={editingFolder.folderName}
            onSuccess={() => {
              setEditingFolder(null);
            }}
            onCancel={() => {
              setEditingFolder(null);
            }}
          />
        )
      }

      {
        deletingFolder && (
          <DeleteFolder
            folderId={deletingFolder.folderId}
            folderName={deletingFolder.folderName}
            onSuccess={() => {
              setDeletingFolder(null);
              // 如果当前正在查看被删除的文件夹，则跳转到全部文件
              if (location.search === `?folderId=${deletingFolder.folderId}`) {
                navigate(ROUTES.FILE);
              }
            }}
            onCancel={() => {
              setDeletingFolder(null);
            }}
          />
        )
      }
    </Layout>
  );
};

export default MainLayout; 